/** Take in selectingString and return a raw combatantID (like, checking for Deadline) */
export function getCombatantIdFromSelectingString(selectingString) {
  //Extract ID out of a `deadline::` string
  if (selectingString.match(/^deadline::/)) {
    return selectingString.replace("deadline::", "");
  }

  if (selectingString.match(/^cloudQueueAction::/)) {
    const dataFromString = selectingString.split("::"); //see `cloud-queue-decode` for reference
    return dataFromString[2]; //casterId segment
  }

  return selectingString;
}



// WEBPACK FOOTER //
// ./src/battle/get-combatant-id-from-selecting-string.js